module.exports = __webpack_public_path__ + "media/images/web/home/index/employment-7f7d45b3d10a20af07448886f20be9a3.webp";